<template>
  <div class="course-card-skeleton" aria-hidden="true">
    <div class="skeleton-image" />
    <div class="skeleton-overlay">
      <div class="skeleton-title" />
      <div class="skeleton-meta" />
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
.course-card-skeleton {
  position: relative;
  width: 100%;
  min-width: 0;
  aspect-ratio: 311.03 / 455.9;
  border-radius: 12px;
  overflow: hidden;
  background-color: var(--color-bg-faq, #f5f5f5);
}

.skeleton-image {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  background-position: 0 0;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
}

.skeleton-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40%;
  min-height: 180px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: linear-gradient(180deg, transparent 0%, rgba(15, 43, 101, 0.4) 50%, rgba(15, 26, 48, 0.6) 100%);
  gap: 12px;
}

.skeleton-title {
  height: 28px;
  max-width: 85%;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.25);
  animation: skeleton-pulse 1.2s ease-in-out infinite;
}

.skeleton-meta {
  height: 16px;
  width: 100px;
  border-radius: 4px;
  align-self: flex-end;
  background: rgba(255, 255, 255, 0.2);
  animation: skeleton-pulse 1.2s ease-in-out infinite;
  animation-delay: 0.1s;
}

@keyframes skeleton-shimmer {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 200% 0;
  }
}

@keyframes skeleton-pulse {
  50% {
    opacity: 0.6;
  }
}
</style>
